import React from 'react';
import { StarIcon, MapPinIcon, PhoneIcon, NavigationIcon } from 'lucide-react';
export function StoreLocator() {
  const stores = [{
    name: 'Caversham',
    rating: 4.5,
    reviews: 560,
    phone: '9377 1270',
    address: 'Cnr Benara Rd & Lord St',
    services: ['DIY Dog Wash', 'Pool Testing'],
    image: 'https://cdn.magicpatterns.com/uploads/gYcRdpPc38QZ66AgQ6wmdk/Not_just_another_faceless_online_store_malaga.png'
  }, {
    name: 'Kelmscott',
    rating: 4.6,
    reviews: 378,
    phone: '9390 4290',
    address: '8/2938 Albany Hwy',
    services: ['DIY Dog Wash', 'Aquarium Testing'],
    image: 'https://cdn.magicpatterns.com/uploads/955MqdeHatH5mLbKcwtLuc/Not_just_another_faceless_online_store.png'
  }, {
    name: 'Malaga',
    rating: 4.6,
    reviews: 189,
    phone: '9249 3125',
    address: '3/673 Marshall Rd',
    services: ['Pool Testing', 'Carry to Car'],
    image: 'https://cdn.magicpatterns.com/uploads/gYcRdpPc38QZ66AgQ6wmdk/Not_just_another_faceless_online_store_malaga.png'
  }, {
    name: 'Midland',
    rating: 4.5,
    reviews: 416,
    phone: '9250 2612',
    address: '1 Clayton St',
    services: ['DIY Dog Wash', 'Carry to Car'],
    image: 'https://cdn.magicpatterns.com/uploads/955MqdeHatH5mLbKcwtLuc/Not_just_another_faceless_online_store.png'
  }, {
    name: 'Wangara',
    rating: 4.6,
    reviews: 340,
    phone: '9309 3320',
    address: '2/21 Prindiville Dr',
    services: ['DIY Dog Wash', 'Pool Testing'],
    image: 'https://cdn.magicpatterns.com/uploads/gYcRdpPc38QZ66AgQ6wmdk/Not_just_another_faceless_online_store_malaga.png'
  }, {
    name: 'Whitfords',
    rating: 4.5,
    reviews: 87,
    phone: '9401 3100',
    address: '15 Banks Ave',
    services: ['Aquarium Testing', 'Carry to Car'],
    image: 'https://cdn.magicpatterns.com/uploads/955MqdeHatH5mLbKcwtLuc/Not_just_another_faceless_online_store.png'
  }];
  return <section className="section-padding bg-white relative" data-id="element-277">
      {/* Stylized Map Background */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none" style={{
      backgroundImage: 'radial-gradient(#0047AB 1px, transparent 1px)',
      backgroundSize: '20px 20px'
    }} data-id="element-278"></div>

      <div className="container-wide relative z-10" data-id="element-279">
        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-280">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-blue-100 text-brand-blue mb-6 shadow-sm" data-id="element-281">
            <MapPinIcon className="w-8 h-8" data-id="element-282" />
          </div>
          <h2 className="font-heading font-extrabold text-4xl md:text-5xl text-gray-900 mb-4" data-id="element-283">
            Find Your Local Store
          </h2>
          <p className="text-lg text-gray-600" data-id="element-284">
            Six stores across Perth, open 7 days. Real staff ready to help.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-285">
          {stores.map((store, index) => <div key={index} className="bg-white rounded-2xl overflow-hidden flex flex-col shadow-sm hover:shadow-elevated transition-all duration-300 border border-gray-100 group" data-id="element-286">
              {/* Store Photo */}
              <div className="h-48 relative overflow-hidden" data-id="element-287">
                <img src={store.image} alt={`${store.name} Store`} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-288" />
              </div>

              {/* Store Details */}
              <div className="p-6 flex flex-col flex-grow" data-id="element-289">
                <div className="flex justify-between items-start mb-4" data-id="element-290">
                  <div data-id="element-291">
                    <h3 className="font-heading font-bold text-2xl text-gray-900 mb-1 flex items-center gap-2 group-hover:text-brand-blue transition-colors" data-id="element-292">
                      {store.name}
                    </h3>
                    <div className="flex items-center gap-1.5 text-sm" data-id="element-293">
                      <div className="flex text-yellow-500" data-id="element-294">
                        <StarIcon className="w-4 h-4 fill-current" data-id="element-295" />
                      </div>
                      <span className="font-bold text-gray-900" data-id="element-296">
                        {store.rating}
                      </span>
                      <span className="text-gray-500" data-id="element-297">({store.reviews})</span>
                    </div>
                  </div>
                  <span className="badge-green whitespace-nowrap shadow-sm" data-id="element-298">
                    Open 7 Days
                  </span>
                </div>

                <div className="mb-4 space-y-2" data-id="element-299">
                  <div className="flex items-center gap-2 text-gray-700" data-id="element-300">
                    <PhoneIcon className="w-4 h-4 text-brand-blue" data-id="element-301" />
                    <span className="font-medium" data-id="element-302">{store.phone}</span>
                  </div>
                  <div className="flex items-start gap-2 text-gray-600 text-sm" data-id="element-303">
                    <MapPinIcon className="w-4 h-4 text-brand-blue flex-shrink-0 mt-0.5" data-id="element-304" />
                    <span data-id="element-305">{store.address}</span>
                  </div>
                </div>

                <div className="mb-6 flex-grow" data-id="element-306">
                  <div className="text-xs font-bold text-gray-400 mb-2 uppercase tracking-wider" data-id="element-307">
                    Key Services
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-308">
                    {store.services.map((service, i) => <span key={i} className="px-2.5 py-1 bg-warm-50 text-gray-700 text-xs rounded-md font-medium border border-warm-200" data-id="element-309">
                        {service}
                      </span>)}
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-3 mt-auto" data-id="element-310">
                  <button className="btn-primary py-3 text-sm flex items-center justify-center gap-1.5 active:scale-95" data-id="element-311">
                    <NavigationIcon className="w-4 h-4" data-id="element-312" />
                    Directions
                  </button>
                  <button className="btn-secondary py-3 text-sm flex items-center justify-center gap-1.5 bg-white active:scale-95" data-id="element-313">
                    <PhoneIcon className="w-4 h-4" data-id="element-314" />
                    Call Store
                  </button>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}